import React, { useEffect, useState } from "react";
import { axiosClient } from "@/lib/axiosClient";
import { Navigate, 
    // useLocation 
} from "react-router-dom"; // [PERUBAHAN] useLocation tidak wajib dipakai di logic baru, tapi dibiarkan saja
import { Loader2 } from "lucide-react";
import MaintenancePage from "@/pages/public/MaintenancePage";
import type { AppConfig } from "@/types/config";

// Definisikan props component
interface SiteGuardProps {
    children: React.ReactNode;
}

const SiteGuard: React.FC<SiteGuardProps> = ({ children }) => {
    const [config, setConfig] = useState<AppConfig | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    // const location = useLocation();

    // Fungsi cek login (Sesuaikan dengan logic auth Anda, misal cek token)
    const isAuthenticated = (): boolean => {
        // Cek localStorage 'user' sesuai kode handleLogin Anda
        const userSession = localStorage.getItem("user");
        return !!userSession;
    };

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                // Sesuaikan base URL API Anda
                const response = await axiosClient.get<{ data: AppConfig } | AppConfig>("/config-app");

                // Handle jika response langsung object atau dibungkus 'data'
                const configData = 'data' in response.data ? response.data.data : response.data;

                // Type assertion/casting jika perlu, tapi axios generic di atas sudah membantu
                setConfig(configData as AppConfig);
            } catch (error) {
                console.error("Gagal memuat konfigurasi aplikasi:", error);
                // Fallback: Jika error, anggap public agar aplikasi tetap jalan (opsional)
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []);

    if (loading) {
        return (
            <div className="h-screen w-full flex items-center justify-center bg-white">
                <Loader2 className="animate-spin w-10 h-10 text-primary" />
            </div>
        );
    }

    // Jika config gagal load sama sekali, loloskan saja (Fail Open)
    if (!config) {
        return <>{children}</>;
    }

    const { site_status, site_status_until } = config;

    // --- LOGIKA WAKTU ---
    const now = new Date();
    // Ganti spasi dengan T agar valid di Constructor Date Safari/Firefox
    const untilDate = new Date(site_status_until.replace(" ", "T"));

    // Status dianggap AKTIF jika waktu sekarang KURANG DARI waktu 'until'
    const isStatusActive = now < untilDate;

    // 1. Cek Maintenance
    // Jika status maintenance DAN waktunya belum habis -> Tampilkan Maintenance
    if (site_status === "maintenance" && isStatusActive) {
        return <MaintenancePage />;
    }

    // 2. Cek Private
    // Jika status private DAN waktunya belum habis -> Cek Login
    if (site_status === "private" && isStatusActive) {

        // [BARU] Logika: Jika User SUDAH login (Admin/Panitia), izinkan akses (Bypass)
        if (isAuthenticated()) {
            return <>{children}</>;
        }

        // [PERUBAHAN] Jika User BELUM login (Tamu/Umum), arahkan ke Countdown
        // Sebelumnya: return <Navigate to="/login" state={{ from: location }} replace />;
        return <Navigate to="/countdown" replace />;
    }

    // 3. Default: Public atau Status Aktif sudah expired -> Tampilkan Halaman
    return <>{children}</>;
};

export default SiteGuard;